import { message } from "antd";
import { useEffect, useState } from "react";
import { isRequestCancelled } from "apiServices/finalProductInspectionService";

/** Loads a dropdown list once; `loader` must be a stable function reference. */
const useActiveList = (loader, errorMessage) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const controller = new AbortController();
    loader(controller.signal)
      .then(setItems)
      .catch((err) => {
        if (!isRequestCancelled(err)) message.error(err?.message || errorMessage);
      })
      .finally(() => {
        if (!controller.signal.aborted) setLoading(false);
      });
    return () => controller.abort();
  }, [loader, errorMessage]);

  return [items, loading];
};

export default useActiveList;
